<template>
  <div ref="layout" v-loading="loading" class="page-form page-base">
    <h3 class="title">终端团购下单</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <!-- 页面详情状态 -->
        <form-button v-if="pageMode == 'edit'" @click="$router.go(-1)">返回</form-button>
        <!-- 页面新建状态 -->
        <template v-if="$_has(['WLY001', 'WLY002', 'WLY015', 'WLYALL']) && !conditions.OBJECT_ID">
          <form-button type="primary" @click="changeStatus('SAVE')">保存</form-button>
        </template>
        <template v-if="conditions.OBJECT_ID">
          <template v-if="conditions.STATUS === 'E0004' && $_has(['WLY001', 'WLY002', 'WLYALL']) && conditions.invo_infoid">
            <form-button v-if="!showEdit" @click="orderModify">修改</form-button>
          </template>
          <template v-else-if="conditions.STATUS === 'E0003' && $_has(['WLYALL', 'WLY002'])">
            <form-button v-if="!showEdit" @click="orderModify">修改</form-button>
          </template>
          <template v-else-if="conditions.STATUS === 'E0007' && $_has(['WLYALL'])">
            <form-button v-if="!showEdit" @click="orderModify">修改</form-button>
          </template>
          <template v-else-if="conditions.STATUS === 'E0008' && $_has(['WLY002', 'WLYALL'])">
            <form-button v-if="!showEdit" @click="orderModify">修改</form-button>
          </template>
          <template v-else-if="conditions.STATUS === 'E0013' && $_has(['WLYALL'])">
            <form-button v-if="!showEdit" @click="orderModify">修改</form-button>
          </template>
          <template v-else-if="conditions.STATUS === 'E0002'">
            <template v-if="$_has(['WLYALL', 'WLY014'])">
              <form-button v-if="!showEdit" @click="orderModify">修改</form-button>
            </template>
            <template v-if="$_has('WLY001')">
              <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
              <form-button icon="form-advance" @click="changeStatus('CANCEL')">取消</form-button>
            </template>
          </template>
          <template v-else-if="conditions.STATUS !== 'E0006' && $_has(['WLYALL', 'WLY001', 'WLY002']) && !showEdit">
            <form-button @click="orderModify">修改</form-button>
          </template>
          <template v-if="conditions.STATUS !== 'E0006' && !showEdit && $_has(['WLYALL', 'WLY002'])">
            <form-button @click="orderlock('UNLOCK')">订单解锁</form-button>
          </template>
        </template>
        <!-- 修改状态 -->
        <template v-if="showEdit">
          <form-button @click="orderDisplay">显示</form-button>
          <template v-if="conditions.STATUS === 'E0002'">
            <form-button v-if="$_has(['WLYALL'])" type="primary" @click="changeStatus('SAVE')">保存</form-button>
            <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
          <template v-if="conditions.STATUS === 'E0003' && $_has(['WLYALL', 'WLY002', 'WLY013'])">
            <form-button @click="changeStatus('APPROVE')">审核通过</form-button>
            <!-- <form-button @click="changeStatus('REJECT')">审核拒绝</form-button> -->
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
          <template v-if="conditions.STATUS === 'E0004' && !conditions.invo_infoid && $_has(['WLY002', 'WLYALL'])">
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
          <template v-if="conditions.STATUS === 'E0007' & $_has('WLYALL')">
            <form-button @click="changeStatus('APPROVE')">审核通过</form-button>
            <!-- <form-button @click="changeStatus('REJECT')">审核拒绝</form-button> -->
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
          <template v-if="conditions.STATUS === 'E0008' && $_has(['WLY002', 'WLYALL'])">
            <form-button @click="changeStatus('APPROVE')">审核通过</form-button>
            <!-- <form-button @click="changeStatus('REJECT')">审核拒绝</form-button> -->
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
          <template v-if="conditions.STATUS === 'E0013' && $_has(['WLY002','WLY003','WLYALL'])">
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
        </template>
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        label-width="100px"
        :model="conditions"
        :rules="rules"
        :disabled="isEdit"
        :show-message="false"
      >
        <common-title title="抬头明细" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="订单编号">
              <el-input
                :value="conditions.OBJECT_ID"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="订单类型">
              <el-select
                :value="conditions.PROCESS_TYPE"
                placeholder=""
                type="select"
                clearable
                disabled
              >
                <el-option
                  v-for="item in selectDataOptions['A0043']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input
                :value="conditions.CUST_NAME"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="CUSTOMER" label="客户编号">
              <wly-input
                v-model="conditions.CUSTOMER"
                clearable
                input-type="customer"
                :disabled="role.ROLE === 'WLY001'"
                @enter="handleEnter"
                @handleSuffixClick="openSelectDialog('client')"
              />
              <!-- <el-input
                v-model="conditions.CUSTOMER"
                placeholder="请输入"
                type="text"
                clearable
                @focus="openSelectDialog('client')"
              /> -->
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select :value="conditions.CUSTOMER_TYPE" placeholder="" clearable disabled>
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="是否盒外刻字">
              <el-checkbox
                :value="conditions.ZZFLD000099"
                disabled
                true-label="X"
                false-label=""
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="外箱喷码内容">
              <el-input
                :value="conditions.ZZFLD000098"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="终端名称">
              <el-input
                :value="conditions.ZZFLD00008X"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="访销员">
              <el-input
                :value="conditions.ZZFLD00008Z"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="终端团购渠道">
              <el-checkbox v-model="conditions.ZZFLD00009CX" true-label="X" false-label="" />
            </el-form-item>
          </el-col>

         <el-col :lg="8" :md="12">
            <el-form-item label="定制名称">
              <el-input v-model="conditions.ZCUSTOM_NAME" placeholder="" clearable :disabled="isEdit" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.ZZFLD000028"
                type="textarea"
                resize="none"
                rows="4"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="审核意见">
              <el-input
                v-model="conditions.ZZFLD00000"
                type="textarea"
                rows="4"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                :value="conditions.ZZFLD00002D_DSCR"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-input
                :value="conditions.POSTING_DATE"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-select
                :value="conditions.STATUS"
                placeholder=""
                type="select"
                clearable
                disabled
              >
                <el-option
                  v-for="item in selectDataOptions['A0041']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="区域" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="营销区域" prop="ZZFLD000001">
              <el-select
                v-model="conditions.ZZFLD000001"
                placeholder=""
                type="select"
                :disabled="!selectDataOptions.orgList || selectDataOptions.orgList.length == 1"
                @change="saleCenterChange"
              >
                <el-option
                  v-for="item in selectDataOptions['orgList']"
                  :key="item.zzfld00001h"
                  :label="item.mc_short"
                  :value="item.zzfld00001h"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="基地">
              <el-input
                :value="conditions.ZZFLD00003E"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="省区">
              <el-input
                :value="conditions.ZZFLD000002_TEXT"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="城市">
              <el-input
                :value="conditions.ZZFLD000003_TEXT"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="业务员">
              <el-input
                :value="conditions.ZZFLD000004_DSCR"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="运达方" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item prop="ZZFLD00008T" label="收货方编码">
              <el-input
                v-model="conditions.ZZFLD00008T"
                type="text"
                clearable
                @focus="openSelectDialog('contact')"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="收货方名称">
              <el-input
                :value="conditions.ZZFLD00008T_DSCR"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="联系人">
              <el-input
                :value="conditions.ZZFLD00002L"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="联系电话">
              <el-input
                :value="conditions.ZZFLD00002M"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="收货地址">
              <el-input :value="conditions.ZZFLD00002N" disabled clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="form-btns">
          <span class="form-btns-label">新开发客户？</span>
          <el-button
            type="primary"
            size="mini"
            @click="openSelectDialog('newClient', {}, 'client')"
          >新增我的客户</el-button>
          <el-button
            type="primary"
            size="mini"
            @click="openSelectDialog('newClient', {}, 'address')"
          >新增地址</el-button>
        </div>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="销售订单行项目" :custome-config="() => vxeShowCustom('orderDetail')">
        <template #button>
          <table-button name="save" tip="保存" @click="updateSaleItem" />
          <table-button name="add" tip="增加" @click="tableEvent('add')" />
          <table-button name="delete" tip="删除" @click="tableEvent('del')" />
        </template>
        <vxe-grid
          ref="orderDetail"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          show-overflow
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :cell-class-name="cellClassName"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #ORDERED_PROD="{row}">
            <wly-input
              v-model="row.ORDERED_PROD"
              size="mini"
              :disabled="isEdit"
              input-type="salesProduct"
              :sales-query-params="productParams"
              @enter="handleEnter(...arguments, row)"
              @handleSuffixClick="openSelectDialog('product', row)"
            />
          </template>
          <template #ZZFLD000009="{row}">
            <el-input
              v-model.number="row.ZZFLD000009"
              size="mini"
              :disabled="isEdit"
              @keyup.enter.native="updateSaleItem"
            />
          </template>
          <template #ZZFLD00002A="{row}">
            <el-select
              v-model="row.ZZFLD00002A"
              :disabled="(role.ROLE !== 'WLY002' && role.ROLE !== 'WLYALL') ? true : isEdit"
              size="mini"
              placeholder=""
            >
              <el-option
                v-for="item in selectDataOptions['A0037']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </template>
          <template #ZZFLD00002I="{row}">
            <el-input v-model="row.ZZFLD00002I" :disabled="(role.ROLE !== 'WLY002' && role.ROLE !== 'WLYALL') ? true : isEdit" type="number" size="mini" />
          </template>
          <template #ZZFLD00002B="{row}">
            <el-checkbox
              v-model="row.ZZFLD00002B"
              true-label="X"
              false-label=""
              disabled
            >是</el-checkbox>
          </template>
          <template #ZZFLD000008="{row}">
            <el-input
              v-model="row.ZZFLD000008"
              size="mini"
              :disabled="isEdit"
            />
          </template>
          <!-- <template #toolbar /> -->
          <!-- <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <el-input
                v-if="gridOptions.columnsFieldTypes[item.field] == 'input' && item.field == 'ZZFLD000009'"
                v-model.number="row[item.field]"
                size="mini"
                :disabled="isEdit"
                @keyup.enter.native="updateSaleItem"
              />
              <el-input
                v-else-if="gridOptions.columnsFieldTypes[item.field] == 'input'"
                v-model="row[item.field]"
                size="mini"
                :disabled="isEdit"
                @keyup.enter.native="updateSaleItem"
              />
              <wly-input
                v-else-if="gridOptions.columnsFieldTypes[item.field] == 'selectProduct'"
                v-model="row[item.field]"
                size="mini"
                :disabled="isEdit"
                input-type="salesProduct"
                :sales-query-params="productParams"
                @enter="handleEnter(...arguments, row)"
                @handleSuffixClick="openSelectDialog('product', row)"
              />
              <el-select
                v-else-if="gridOptions.columnsFieldTypes[item.field] == 'select'"
                v-model="row[item.field]"
                :disabled="isEdit"
                size="mini"
                placeholder="请选择"
              >
                <el-option
                  v-for="item2 in selectDataOptions['A0037']"
                  :key="item2.value"
                  :label="item2.name"
                  :value="item2.value"
                />
              </el-select>
              <el-checkbox
                v-else-if="gridOptions.columnsFieldTypes[item.field] == 'checkbox'"
                v-model="row[item.field]"
                :disabled="isEdit"
                size="mini"
              >是</el-checkbox>
              <span v-else-if="gridOptions.columnsFieldTypes[item.field] == 'NUMBER_INT'">
                {{ Number(row.NUMBER_INT) }}
              </span>
              <span v-else>{{ row[item.field] }}</span>
            </div>
          </template> -->
        </vxe-grid>
      </TableCommon>
      <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
        <template #button>
          <el-upload
            ref="upload"
            accept=".png,.pdf,.jpg"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" name="upload" tip="上传" />
          </el-upload>
          <table-button name="delete" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFile.columns"
          :data="gridOptionsFile.data"
        >
          <template #FILENAME="{ row }">
            <span class="blue" @click="downLoadFile(row)">{{ row.FILENAME }}</span>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="状态变更记录" :custome-config="() => vxeShowCustom('history')">
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsHistory.columns"
          :data="gridOptionsHistory.data"
        />
      </TableCommon>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <client-add
          v-if="showDialogType === 'newClient'"
          ref="dialogEdit"
          :init-data="initClientAddData"
          :mode="clientMode"
        />
        <client-select v-if="showDialogType === 'client'" ref="dialogEdit" />
        <sale-product-select
          v-if="showDialogType === 'product'"
          ref="dialogEdit"
          :info="productParams"
        />
        <client-group-arrival-select
          v-if="showDialogType === 'contact'"
          ref="dialogEdit"
          mode="ZDTG"
          :info="conditions"
        />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-check"
          @click="submitHandle"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatSapTime, formatSapDate, formatSapFileSize } from '@/mixins/index'
import { sapDownloadFile } from '@/utils/frontExport'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiSapSingleClientInfo, apiOrderLock } from '@/api/common'
import { apiZDTGUpdateSaleItem, apiZDTGSave, getOrderDetail } from '@/api/sap/order-sap'
import { apiInitClientAdd, apiClientAdd } from '@/api/client'
const SaleProductSelect = () => import('@/components/dialog/SaleProductSelect')
const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
const ClientAdd = () => import('@/components/dialog/ClientAdd.vue')
const ClientGroupArrivalSelect = () => import('@/components/dialog/ClientGroupArrivalSelect')

export default {
  components: {
    SaleProductSelect,
    ClientSelect,
    ClientAdd,
    ClientGroupArrivalSelect
  },
  data() {
    const rules = {
      CUSTOMER: [{ required: true, message: '请选择客户', trigger: 'change' }],
      ZZFLD00008T: [{ required: true, message: '请选择收货方单位编码', trigger: 'change' }],
      GRPUTID: [{ required: true, message: '请选择团购段位', trigger: 'change' }],
      BUSOPPID: [{ required: true, message: '请选择商机', trigger: 'change' }],
      ZZFLD000001: [{ required: true, message: '请选择营销单元', trigger: 'change' }]
    }
    return {
      rules,
      showEdit: false,
      pageMode: 'add',
      validRules: {
        ORDERED_PROD: [{ required: true }],
        ZZFLD000009: [{ required: true }]
      },
      showDialogType: '',
      errorList: [],
      showDialog: false,
      dialogTitle: '',
      clientMode: 'add',
      currentDetail: {},
      mode: '',
      selectDataOptions: {},
      initClientAddData: {},
      productParams: {
        PROCESS_TYPE: 'ZS02',
        CUSTOMER: '',
        ZZFLD00002J: 'V014',
        mode: 'ZDTG'
      },
      conditions: {
        OBJECT_ID: '', // 订单编号
        PROCESS_TYPE: 'ZS02', // 订单类型
        CUSTOMER: '', // 客户编码
        CUST_NAME: '', // 客户名称
        CUSTOMER_TYPE: '', // 客户类型
        ZZFLD00000: '', // 审核意见
        ZZFLD000028: '', // 备注
        ZZFLD00002D: '', // 创建人编号
        ZZFLD00002D_DSCR: '', // 创建人描述
        POSTING_DATE: '', // 创建时间
        STATUS: 'E0001', // 状态
        ZZFLD000001: '', // 营销单元
        ZZFLD00003E: '', // 基地
        ZZFLD000003_TEXT: '',
        ZZFLD000002_TEXT: '',
        ZZFLD00009CX: '', // 终端团购渠道
        ZZFLD00008Z: '', // 访销员
        ZZFLD00008W: '', // 终端ID
        ZZFLD00008X: '', // 终端名称
        ZZFLD000002: '', // 省区
        ZZFLD000003: '', // 城市
        ZZFLD000004: '', // 业务员
        ZZFLD000004_DSCR: '', // 业务员描述
        ZCUSTOM_NAME: '',
        ZZFLD00002J: 'V014', // 客户性质
        ZZFLD00002K: '', // 发货类型
        ZZFLD00002L: '', // 收货联系人
        ZZFLD00002M: '', // 收货联系电话
        ZZFLD00008T: '', // 收货方
        ZZFLD00008T_DSCR: '', // 收货方
        ZZFLD00003C: 'WEB'
      },
      loading: false,
      gridOptions: {
        columns: [
          { filed: 'checkbox', type: 'checkbox', title: '', width: 40 },
          {
            field: 'NUMBER_INT',
            title: '行号',
            width: 50,
            formatter: ({ cellValue }) => Number(cellValue)
          },
          {
            field: 'ORDERED_PROD',
            title: '产品编码',
            width: 180,
            slots: { default: 'ORDERED_PROD' },
            editRender: {},
            params: { bgEdit: true }
          },
          {
            field: 'DESCRIPTION',
            title: '产品描述',
            width: 250
          },
          {
            field: 'ZZFLD00002S',
            title: '规格型号',
            width: 180
          },
          {
            field: 'ZZFLD00002T',
            title: '单位',
            width: 80
          },
          {
            field: 'ZZFLD00002U',
            title: '数量',
            width: 80
          },
          {
            field: 'ZZFLD000009',
            title: '件数',
            width: 80,
            slots: { default: 'ZZFLD000009' },
            editRender: {},
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002E',
            title: '税率',
            width: 80
          },
          {
            field: 'ZZFLD00002X',
            title: '含税单价',
            width: 100
          },
          {
            field: 'ZZFLD00002Z',
            title: '税价合计',
            width: 100
          },
          {
            field: 'ZZFLD00002A',
            title: '折扣类型',
            width: 100,
            slots: { default: 'ZZFLD00002A' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002F',
            title: '单品折扣',
            width: 100
          },
          {
            field: 'ZZFLD00002G',
            title: '折后含税单价',
            width: 180
          },
          {
            field: 'ZZFLD00002I',
            title: '折扣额',
            width: 100,
            slots: { default: 'ZZFLD00002I' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002O',
            title: '已占用开票数量',
            width: 180
          },
          {
            field: 'ZZFLD000035',
            title: '已占用开票件数',
            width: 180
          },
          {
            field: 'ZZFLD000007',
            title: '累计开票数量',
            width: 180
          },
          {
            field: 'ZZFLD000032',
            title: '累计开票件数',
            width: 180
          },
          {
            field: 'ZZFLD00002B',
            title: '是否关闭',
            width: 100,
            slots: { default: 'ZZFLD00002B' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD000008',
            title: '备注',
            width: 180,
            slots: { default: 'ZZFLD000008' },
            params: { bgEdit: true }
          }
        ],
        data: [],
        delData: [],
        columnsFieldTypes: {
          default: '',
          ORDERED_PROD: 'selectProduct',
          ZZFLD000009: 'input',
          ZZFLD00002A: 'select',
          ZZFLD00002I: 'input',
          ZZFLD00002B: 'checkbox',
          ZZFLD000008: 'input',
          NUMBER_INT: 'NUMBER_INT'
        }
      },
      gridOptionsFile: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 40 },
          { field: 'FILENAME', title: '附件名称', slots: { default: 'FILENAME' }},
          { field: 'MIMETYPE', title: '附件类型' },
          { field: 'FILELENGTH', title: '大小', formatter: ({ cellValue }) => formatSapFileSize(cellValue) },
          { field: 'CREATED_DATE', title: '上传日期', formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'CREATED_TIME', title: '上传时间', formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        data: [],
        delData: []
      },
      gridOptionsLinkBill: {
        columns: [
          {
            field: 'orderDate',
            title: '单据编号'
          },
          {
            field: 'orderDate',
            title: '单据类型'
          },
          {
            field: 'orderDate',
            title: '创建日期'
          }
        ],
        data: []
      },
      gridOptionsHistory: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'ZZFLD00000U', title: '操作人' },
          { field: 'ZZFLD000031', title: '操作人姓名' },
          { field: 'ZZFLD00000V_TEXT', title: '状态' },
          { field: 'ZZFLD00000W', title: '变更日期', formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'ZZFLD00000X', title: '变更时间', formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['role', 'customerInfo']),
    isEdit() {
      if (this.conditions.OBJECT_ID) {
        return !this.showEdit
      } else {
        return false
      }
    }
  },
  watch: {
    'conditions.CUSTOMER': {
      handler(nv) {
        this.productParams.CUSTOMER = nv
      }
    },
    'gridOptions.data': {
      handler(nv, ol) {
        nv.forEach((item, i) => {
          item.NUMBER_INT = (i + 1) * 10
        })
      },
      deep: true
    }
  },
  created() {
    const pageQuery = this.$route.query
    if (pageQuery?.object_id) {
      this.pageMode = 'edit'
      this.initOrderInfoById(pageQuery.object_id, 1)
    } else {
      if (this.role.ROLE === 'WLY001') {
        const orgList = this.customerInfo.yxdy.filter(v => v.mc_short !== '其他销售类型')
        this.conditions.CUSTOMER = this.customerInfo.info.partner
        this.conditions.CUSTOMER_TYPE = this.customerInfo.info.zzfld000016
        this.conditions.CUST_NAME = this.customerInfo.info.name_org1
        this.conditions.ZZFLD000001 = orgList[0].zzfld00001h
        this.conditions.ZZFLD00003E = orgList[0].mc_short_jd
        this.conditions.ZZFLD000002 = this.customerInfo.info.region
        this.conditions.ZZFLD000002_TEXT = this.customerInfo.info.bezei
        this.conditions.ZZFLD000003 = this.customerInfo.info.city_code
        this.conditions.ZZFLD000003_TEXT = this.customerInfo.info.city_name
        this.conditions.ZZFLD000004 = this.customerInfo.info.sales_emp
        this.conditions.ZZFLD000004_DSCR = this.customerInfo.info.sales_emp_name
        this.productParams.CUSTOMER = this.customerInfo.info.partner
        this.$set(this.selectDataOptions, 'orgList', orgList)
      }
      this.conditions.ZZFLD00002D = this.role.USER_BP
      this.conditions.ZZFLD00002D_DSCR = this.role.login_user
      this.conditions.POSTING_DATE = this.$utilsCommon.parseTime(
        new Date().getTime(),
        '{y}-{m}-{d}'
      )
      this.tableEvent('add')
    }
    // 折扣类型
    this.getSelectDictDataOrigin('A0037')
    // 销售订单状态
    this.getSelectDictDataOrigin('A0041')
    // 销售订单类型
    this.getSelectDictDataOrigin('A0043')
    this.getSelectDictDataOrigin('A0009')
  },
  methods: {
    cellClassName({ column }) {
      return column.params?.bgEdit ? 'cell--bg--edit' : 'cell--bg--default'
    },
    // 根据id查询订单信息
    async initOrderInfoById(OBJECT_ID, type = 0) {
      this.loading = true
      try {
        const res = await getOrderDetail({ OBJECT_ID })
        if (res?.MSGTYPE === 'S') {
          const { DATA } = res
          Object.assign(this.conditions, DATA.INFO)
          this.conditions.invo_infoid = res.INVO_INFOID
          this.gridOptions.data = DATA.ITEM
          this.gridOptionsFile.data = DATA.ATTACHMENT || []
          this.gridOptionsHistory.data = DATA.HISTORY || []

          type && this.initCustome()
        }
      } catch (e) {
        //
      }
      this.loading = false
    },
    async orderModify() {
      const res = await this.orderlock('ADD')
      if (!res) return
      await this.initOrderInfoById(this.conditions.OBJECT_ID)
      this.showEdit = true
    },
    async orderDisplay() {
      const res = await this.orderlock('DELETE')
      if (!res) return
      await this.initOrderInfoById(this.conditions.OBJECT_ID)
      this.showEdit = false
    },
    // 订单解锁
    async orderlock(mode) {
      this.errorList = []
      const params = {
        type: this.conditions.PROCESS_TYPE,
        number: this.conditions.OBJECT_ID,
        status: mode === 'ADD' ? 1 : 2
      }
      if (mode === 'UNLOCK') {
        await this.$confirm('解锁前请确认当前没有其他人修改此订单！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      }
      const { data } = await apiOrderLock(params)
      if (data.status && params.status === 1) {
        this.errorList = [data.message]
        return false
      }
      return true
    },
    async confirmMode(type) {
      const types = {
        SUBMIT: '提交',
        CANCEL: '取消',
        REJECT: '审核拒绝',
        APPROVE: '审核通过'
      }
      if (!types[type]) {
        return Promise.resolve()
      }
      await this.$confirm(`是否确认${types[type]}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    },
    // 保存 提交 确认  新建 E0001,已保存待提交 E0002,已提交待审核 E0003, 审核通过 E0004,审核拒绝 E0005,已取消 E0006
    changeStatus(status) {
      this.$refs['form'].validate(async(valid, err) => {
        if (valid) {
          // await this.confirmMode(status)
          const params = {
            MODE: status,
            info: this.conditions,
            item: this.gridOptions.data.concat(this.gridOptions.delData),
            ATTACHMENT: this.gridOptionsFile.data.concat(this.gridOptionsFile.delData)
          }
          params.user_bp = this.role.USER_BP
          this.loading = true
          this.errorList = []
          const result = await apiZDTGSave(params)
          if (result?.MSGTYPE === 'S') {
            this.$message.success(result.MESSAGE)
            this.gridOptionsFile.delData = []
            this.gridOptions.delData = []
            this.conditions.OBJECT_ID = result.DATA.INFO.OBJECT_ID
            this.orderDisplay()
          } else {
            this.errorList.push(result.MESSAGE)
            this.loading = false
            return
          }

          const { DATA } = result
          Object.assign(this.conditions, DATA.INFO)
          this.gridOptions.data = DATA.ITEM
          this.gridOptionsFile.data = DATA.ATTACHMENT || []
          this.gridOptionsHistory.data = DATA.HISTORY || []
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    // 查询客户信息
    async initCustome() {
      const params = {
        partner: this.conditions.CUSTOMER,
        user_bp: this.role.USER_BP
      }
      const { data } = await apiSapSingleClientInfo(params)
      const orgList = data.yxdy.filter(v => v.mc_short !== '其他销售类型')
      this.$set(this.selectDataOptions, 'orgList', orgList)
    },
    // 初始化数据字典
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 选择营销单元
    saleCenterChange(e) {
      const checkedData = this.selectDataOptions.orgList.find(v => v.zzfld00001h === e)
      this.conditions.ZZFLD00003E = checkedData.mc_short_jd
      this.productParams.zzfld000001 = e
      this.errorList = []
      this.gridOptions.data = []
      this.gridOptions.delData = []
      this.gridOptionsFile.data = []
      this.gridOptionsFile.delData = []
      this.gridOptionsLinkBill.data = []
      this.gridOptionsHistory.data = []

      this.tableEvent('add')
    },
    tableEvent(btn) {
      const orderDetailsEmpty = {}
      this.gridOptions.columns.forEach(v => {
        !v.type && (orderDetailsEmpty[v.field] = '')
      })
      switch (btn) {
        case 'add':
          // orderDetailsEmpty.NUMBER_INT = (this.gridOptions.data.length + 1) * 10
          this.gridOptions.data.push(orderDetailsEmpty)
          break
        case 'del':
          this.delDetail()
          break
      }
    },
    // 删除明细
    delDetail() {
      const checkedData = this.$refs.orderDetail.getCheckboxRecords()
      if (!checkedData?.length) return this.$message.warning('请选择要删除的数据！')
      const ids = checkedData.map(v => {
        // 给需要删除的行项目打标机
        v.MODE = 'D'
        return v._X_ID
      })
      this.gridOptions.data = this.gridOptions.data.filter(item => {
        return !ids.includes(item._X_ID)
      })
      if (this.conditions.OBJECT_ID) {
        // 保存删除明细中有guid的行项目
        this.gridOptions.delData = this.gridOptions.delData.concat(checkedData.filter(v => v.GUID))
      }
    },
    // 删除合同附件
    delUpload() {
      const checkedData = this.$refs.fileTable.getCheckboxRecords()
      if (!checkedData?.length) return this.$message.warning('请选择要删除的数据！')
      const ids = checkedData.map(v => {
        v.DELETE_FLAG = 'X'
        return v._X_ID
      })
      this.gridOptionsFile.data = this.gridOptionsFile.data.filter(item => {
        return !ids.includes(item._X_ID)
      })
      if (this.conditions.OBJECT_ID) {
        // 保存删除附件中有guid的
        this.gridOptionsFile.delData = this.gridOptionsFile.delData.concat(checkedData.filter(v => v.GUID))
      }
    },
    async uploadFile(file) {
      const _this = this
      const reader = new FileReader()
      reader.readAsArrayBuffer(file.raw)
      var strArr = []
      reader.onload = function() {
        var unitArray = new Uint8Array(this.result)
        for (var i = 0; i < unitArray.length; i++) {
          var u_arr16 = unitArray[i].toString(16).toLocaleUpperCase()
          if (u_arr16.length < 2) {
            u_arr16 = '0' + u_arr16
          }
          strArr.push(u_arr16)
        }

        strArr = strArr.join('')

        const dateTime = new Date().getTime()

        const fileData = {
          FILENAME: file.name,
          MIMETYPE: file.raw.type,
          DOC_TYPE: file.raw.type,
          XCONTENT: strArr,
          FILELENGTH: file.size,
          ZZFLD00002D: _this.role.USER_BP,
          ZZFLD00002D_DSCR: _this.role.login_user,
          CREATED_DATE: _this.$utilsCommon.parseTime(dateTime, '{y}{m}{d}'),
          CREATED_TIME: _this.$utilsCommon.parseTime(dateTime, '{h}{i}{s}')
        }

        _this.gridOptionsFile.data.unshift(fileData)
      }
    },
    // 下载附件
    downLoadFile(row) {
      sapDownloadFile(row.XCONTENT, row.FILENAME)
    },
    // 添加客户地址
    async addGroupArrivalCustomer(res) {
      const result = await apiClientAdd(res)
      if (result.MSGTYPE === 'S') {
        this.$message.success(result.MESSAGE)
      } else {
        return this.$message.warning(result.MESSAGE)
      }

      this.conditions.ZZFLD00008T_DSCR = result.DATA.NAME_LAST
      this.conditions.ZZFLD00008T = result.DATA.PARTNER
      this.conditions.ZZFLD00002L = result.DATA.C_O_NAME
      this.conditions.ZZFLD00002M = result.DATA.TEL_NUMBER
      // this.conditions.ZZFLD00002N = result.DATA.STREET
      this.conditions.ZZFLD00002N = result.DATA.STREET

      this.conditions.MARKTSPT = result.DATA.MARKTSPT

      this.showDialog = false
    },
    async checkClientAdd(mode) {
      if (mode === 'address' && !this.conditions.ZZFLD00008T) {
        return this.$message.warning('请选择收货方')
      }
      // 初始化新增数据
      const params = {
        mode: mode === 'client' ? '' : 'X',
        head: this.conditions
      }
      params.role = this.role.ROLE
      const result = await apiInitClientAdd(params)
      if (result?.MSGTYPE !== 'S') {
        return this.$message.warning(result.MESSAGE)
      }
      const { DATA } = result
      this.initClientAddData = { head: DATA.HEAD, info: DATA.INFO }
      this.mode = mode
      this.dialogTitle = mode === 'client' ? '新增客户' : '新增地址'
      this.showDialog = true
    },
    // 打开窗口
    openSelectDialog(type, row = {}, mode) {
      this.currentDetail = row
      this.showDialogType = type
      if (type === 'newClient') {
        return this.checkClientAdd(mode)
      }
      this.dialogTitle = {
        product: '产品选择',
        client: '客户选择',
        contact: '收货方选择',
        groupUnit: '团购客户选择',
        businessOpp: '商机选择'
      }[type]
      this.showDialog = true
    },
    async updateSaleItem() {
      const params = {
        info: this.conditions,
        item: this.gridOptions.data
      }
      this.errorList = []
      const result = await apiZDTGUpdateSaleItem(params)

      if (result?.MSGTYPE === 'E') {
        this.errorList.push(result.MESSAGE)
      }

      const { DATA } = result
      Object.assign(this.conditions, DATA.INFO)
      this.gridOptions.data = DATA.ITEM
    },
    selectClient(res) {
      const orgList = res.orgList.filter(v => v.mc_short !== '其他销售类型')
      this.conditions.CUSTOMER = res.partner
      this.conditions.CUSTOMER_TYPE = res.zzfld000016
      this.conditions.CUST_NAME = res.name_org1
      this.conditions.ZZFLD000001 = orgList[0].zzfld00001h
      this.conditions.ZZFLD00003E = orgList[0].mc_short_jd
      this.conditions.ZZFLD000002 = res.region
      this.conditions.ZZFLD000002_TEXT = res.bezei
      this.conditions.ZZFLD000003 = res.city_code
      this.conditions.ZZFLD000003_TEXT = res.city_name
      this.conditions.ZZFLD000004 = res.sales_emp
      this.conditions.ZZFLD000004_DSCR = res.sales_emp_name
      this.productParams.CUSTOMER = res.partner
      this.$set(this.selectDataOptions, 'orgList', orgList)

      this.gridOptions.data = []
      this.gridOptions.delData = []
      this.gridOptionsFile.data = []
      this.gridOptionsFile.delData = []
      this.gridOptionsLinkBill.data = []
      this.gridOptionsHistory.data = []

      this.tableEvent('add')
    },
    selectProduct(res) {
      this.currentDetail.ORDERED_PROD = res.PRODUCT_ID
      this.currentDetail.UNIT = res.MSEHT
      this.currentDetail.DESCRIPTION = res.SHORT_TEXT
      this.currentDetail.ZZFLD00002S = res.NORMS

      this.updateSaleItem()
    },
    receiveSelect(res) {
      this.conditions.ZZFLD00008T_DSCR = res.NAME_ORG1
      this.conditions.ZZFLD00008T = res.PARTNER
      this.conditions.ZZFLD00002L = res.C_O_NAME
      this.conditions.ZZFLD00002M = res.TEL_NUMBER
      this.conditions.ZZFLD00002N = res.STREET
    },
    // 弹窗内的方法这边来处理，方便数据回调在本页面处理
    submitHandle() {
      this.$refs.dialogEdit.submitForm().then(async res => {
        switch (this.showDialogType) {
          case 'product':
            this.selectProduct(res)
            break
          case 'client':
            this.selectClient(res)
            break
          case 'contact':
            this.receiveSelect(res)
            break
          case 'groupUnit':
            this.conditions.INFOTP = res.INFOTP
            this.conditions.GRPUTID = res.ID
            this.conditions.GRPNAME = res.OBJNAME
            break
          case 'businessOpp':
            this.conditions.BUSOPPID = res.ID
            this.conditions.BUSINAME = res.NAME
            break
          case 'newClient':
            this.addGroupArrivalCustomer(res)
            break
        }
        if (this.showDialogType !== 'newClient') {
          this.showDialog = false
        }
      })
    },
    // 控件回车
    async handleEnter(e, type, data, row) {
      // console.log('handleEnter', type, data)
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return

      this.currentDetail = row

      switch (type) {
        case 'customer':
          this.selectClient(data)
          break
        case 'salesProduct':
          this.selectProduct(data)
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/order-manage/terminalGroupBuy.vue